import React from 'react';
import './styles.css';

// Shimmer placeholders shown per widget while its data loads.

export const AnalyticsGraphSkeleton = () => (
  <div className="AnalyticsSkeletonGraph">
    <span className="AnalyticsSkeleton AnalyticsSkeletonCircle" />
    <div className="AnalyticsSkeletonLegend">
      {Array.from({length: 3}, (_, index) => (
        <span className="AnalyticsSkeleton AnalyticsSkeletonLine" key={index} />
      ))}
    </div>
  </div>
);

export const AnalyticsDropdownSkeleton = () => (
  <span className="AnalyticsSkeleton AnalyticsSkeletonDropdown" />
);

export const AnalyticsCardsSkeleton = () => (
  <div className="AnalyticsCardsContainer">
    {Array.from({length: 3}, (_, index) => (
      <span className="AnalyticsSkeleton AnalyticsSkeletonCard" key={index} />
    ))}
  </div>
);

export const AnalyticsTableSkeleton = ({rows = 5}: {rows?: number}) => (
  <div className="AnalyticsSkeletonTable">
    <span className="AnalyticsSkeleton AnalyticsSkeletonTableHeader" />
    {Array.from({length: rows}, (_, index) => (
      <span
        className="AnalyticsSkeleton AnalyticsSkeletonTableRow"
        key={index}
      />
    ))}
  </div>
);

export const AnalyticsCommentsSkeleton = () => (
  <div className="AnalyticsSkeletonComments">
    <span className="AnalyticsSkeleton AnalyticsSkeletonLine" />
    {Array.from({length: 3}, (_, index) => (
      <div className="AnalyticsSkeletonComment" key={index}>
        <span className="AnalyticsSkeleton AnalyticsSkeletonAvatar" />
        <div className="AnalyticsSkeletonCommentBody">
          <span className="AnalyticsSkeleton AnalyticsSkeletonLine" />
          <span className="AnalyticsSkeleton AnalyticsSkeletonCommentText" />
        </div>
      </div>
    ))}
  </div>
);
